// extracted by mini-css-extract-plugin
module.exports = {"text":"OpenButton_text__1osD4","contained":"OpenButton_contained__3QKmP","disabled":"OpenButton_disabled__2jZat","error":"OpenButton_error__12rH1"};